module.exports = __webpack_public_path__ + "static/media/hand.48ececb7.png";